import React from 'react';

import type SearchQuery from '../../../../domain/search_query';
import type SearchQueryItem from '../../../../domain/search_query_item';
import type SelectStore from '../../../../domain/select_store';

import OutlineShortDistanceContainer from './outline/OutlineShortDistanceContainer';

interface Props {
  query: SearchQuery;
  store: SelectStore;
  selectErrors: string[];
  packageErrors?: string[] | null | undefined;
  submitting: boolean;
  handleSelectItem: () => void;
  handleAddItem?: (item_type: 'transport' | 'hotel', e: React.MouseEvent<HTMLElement>) => void;
  handleAdditionalSearch: (queryItem: SearchQueryItem, e: React.FormEvent<HTMLFormElement>) => void;
  additionalSearchErrors?: { [k in string]: string };
  handleRemoveItem?: () => void;
  handleNextButtonClick: (e: React.MouseEvent<HTMLElement>) => void;
  isRequestForm?: boolean; // 旧コメント ArrangementRequestForm
  handleOpenShowSearchBox: () => void;
}

const OutlineWrapperShortDistanceContainer = ({
  query,
  store,
  selectErrors,
  packageErrors,
  handleSelectItem,
  handleAddItem,
  handleAdditionalSearch,
  additionalSearchErrors,
  handleRemoveItem,
  handleNextButtonClick,
  submitting,
  isRequestForm,
  handleOpenShowSearchBox
}: Props) => {
  // MEMO: 旧版コンポーネントを使いたいケースの分岐。パッケージや海外渡航など
  const isShowPackage = store.showPackage;

  const isAirPackageLoading = store.result.type === 'airPackage' && store.packageLoading[store.result.airline];
  const isJrPackageLoading = store.result.type === 'jrPackage' && store.jrPackageLoading;
  const isPackageLoading = isAirPackageLoading || isJrPackageLoading;

  const hasAirPackageErrors = store.result.type === 'airPackage' && packageErrors && packageErrors.length > 0;
  const hasJrPackageErrors =
    store.result.type === 'jrPackage' && store.jrPackageErrors && store.jrPackageErrors.length > 0;
  const hasPackageErrors = hasAirPackageErrors || hasJrPackageErrors;

  const hasNoAirPackageResults =
    store.result.type === 'airPackage' && store.result.packageItems[store.result.airline].length === 0;
  const hasNoJrPackageResults = store.result.type === 'jrPackage' && store.result.jrPackageItems.length === 0;
  const hasNoPackageResults = hasNoAirPackageResults || hasNoJrPackageResults;

  const renderContent = () => {
    // 国際線　はパッケージがない.個別になる
    if (isShowPackage === false) {
      return (
        <OutlineShortDistanceContainer
          query={query}
          store={store}
          selectErrors={selectErrors}
          handleSelectItem={handleSelectItem}
          handleAddItem={handleAddItem}
          handleRemoveItem={handleRemoveItem}
          handleAdditionalSearch={handleAdditionalSearch}
          additionalSearchErrors={additionalSearchErrors}
          handleNextButtonClick={handleNextButtonClick}
          submitting={submitting}
          isRequestForm={isRequestForm || false}
          handleOpenShowSearchBox={handleOpenShowSearchBox}
        />
      );
    }

    if (isPackageLoading) {
      return (
        <>
          <img className="select__loading" src="/images/loading.gif" width={50} height={50} alt="loading" />
          <div className="select__loading-text">パッケージを検索中です</div>
        </>
      );
    }

    if (hasPackageErrors) {
      const errorMessages = hasAirPackageErrors ? packageErrors || [] : store.jrPackageErrors || [];
      return (
        <div className="select-pc__no-results">
          {errorMessages.map(error => (
            <div className="error" key={error}>
              {error}
            </div>
          ))}
        </div>
      );
    }

    if (hasNoPackageResults) {
      return (
        <div className="select-pc__no-results">
          該当のパッケージはありません。
          <br />
          検索条件を変更して再度検索してください。
        </div>
      );
    }

    return (
      <OutlineShortDistanceContainer
        query={query}
        store={store}
        selectErrors={selectErrors}
        handleSelectItem={handleSelectItem}
        handleAddItem={handleAddItem}
        handleRemoveItem={handleRemoveItem}
        handleAdditionalSearch={handleAdditionalSearch}
        additionalSearchErrors={additionalSearchErrors}
        handleNextButtonClick={handleNextButtonClick}
        submitting={submitting}
        isRequestForm={isRequestForm || false}
        handleOpenShowSearchBox={handleOpenShowSearchBox}
      />
    );
  };

  return <div className="select-outline-wrapper">{renderContent()}</div>;
};

export default OutlineWrapperShortDistanceContainer;
